export const data = [
  {
    id: 1,
    title: 'День рождения',
    desc: 'Организуем День Рождения в лазертаге, гидроболе или пейнтболе — и Ваш праздник будет на высшем уровне.',
    icon: null,
    img: '/1.jpg',
  },
  {
    id: 2,
    title: 'Школьные праздники',
    desc: 'Организуем яркие школьные праздники, даря активные и весёлые моменты, которые останутся в памяти надолго.',
    icon: null,
    img: '/2.jpg',
  },
  {
    id: 3,
    title: 'Корпоратив',
    desc: 'Пейнтбол, лазертаг и гидробол — отличный выбор для корпоратива или тимбилдинга, оставляющий яркие эмоции и адреналин надолго.',
    icon: null,
    img: '/33.jpg',
  },
  {
    id: 4,
    title: 'Отдых выходного дня',
    desc: 'Развиваясь с каждым днем, мы предлагаем высококлассный уровень сервиса. Ждем Вас в гости!',
    icon: null,
    img: '/img3.jpg',
  },
];
// desc: 'Лучший способом провести корпоратив или тимбилдинг станет возможность поиграть в пейнтбол, лазертаг и гидрабол. Позитивные эмоции, мощнейший выброс адреналина и сладкое чувство победы не покинут вас ещё долго после игры',

// Более 15 лет мы организуем игры, создавая яркие моменты для школьников. Мы знаем, как сделать школьную жизнь активной и весёлой, а воспоминания о нас останутся с вами на долгое время.
// Отличный способ организовать корпоратив или тимбилдинг — это игры в пейнтбол, лазертаг и гидробол. Яркие эмоции и заряд адреналина будут с вами ещё долго после игры
// Если Вы хотите организовать необычный День Рождения в лазертаге, гираболе или же пейтболе,  то можете быть уверены, что отдых пройдет на достойном уровне.
